export const PRIORITY_VEHICLE_FEATURES = ['diesel_included', 'driver_included'] as const

export type PriorityVehicleFeature = (typeof PRIORITY_VEHICLE_FEATURES)[number]

const FEATURE_ALIASES: Record<string, PriorityVehicleFeature> = {
  'diesel incluido': 'diesel_included',
  'diesel included': 'diesel_included',
  'combustible diesel incluido': 'diesel_included',
  'motorista incluido': 'driver_included',
  'con motorista': 'driver_included',
  'driver included': 'driver_included',
  'chauffeur included': 'driver_included',
}

export function isPriorityVehicleFeature(feature: string): feature is PriorityVehicleFeature {
  return PRIORITY_VEHICLE_FEATURES.includes(feature as PriorityVehicleFeature)
}

function normalizedLabel(value: string): string {
  return value
    .trim()
    .toLocaleLowerCase('es')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
}

export function canonicalVehicleFeature(feature: string): string {
  const trimmed = feature.trim()
  if (!trimmed) return ''
  return FEATURE_ALIASES[normalizedLabel(trimmed)] ?? trimmed
}

export function sortVehicleFeatures(features: string[]): string[] {
  const unique = Array.from(new Set(features.map(canonicalVehicleFeature).filter(Boolean)))
  const priority = PRIORITY_VEHICLE_FEATURES.filter((feature) => unique.includes(feature))
  const standard = unique.filter((feature) => !isPriorityVehicleFeature(feature))
  return [...priority, ...standard]
}
